module.exports = __webpack_public_path__ + "static/media/portfolio_2.173ff820.jpeg";